import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse
} from "../../../APIHelpers/Responses";

export const storeOrderServices = {
  addNewStoreOrder,
  updatedStoreOrder,
  softDeleteRestoreStoreOrder,
  deleteStoreOrder,
  getStoreOrderList,
  getStoreSingleOrder
};

// Add New Store Order
async function addNewStoreOrder(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStoreOrder`,
    headersWithAuth("POST", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Update Store Order
async function updatedStoreOrder(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedStoreOrder`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Soft Delete & Restore Store Order
async function softDeleteRestoreStoreOrder(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStoreOrder`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Delete Store Order
async function deleteStoreOrder(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStoreOrder`,
    headersWithAuth("DELETE", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Get All Store Order
async function getStoreOrderList(status, search, page, length) {
  try {
    const signal = cancelPreviousRequest(`getStoreOrderList`);
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getStoreOrderList/${status}?search=${search || ""}&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getStoreOrderList/${status}?search=${search || ""}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Single Store Order
async function getStoreSingleOrder(OrderId, search, page, length) {
  try {
    const signal = cancelPreviousRequest(`getStoreSingleOrder`);
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getStoreSingleOrder/${OrderId}?search=${search || ""}&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getStoreSingleOrder/${OrderId}?search=${search || ""}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}